import React, { useEffect, useState } from 'react';
import { Drawer, Spin, Tooltip, Typography } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import moment from 'moment';

import AgGrid from "../../../../../../../components/ag-grid-table/index";
import LeftArrow from '../../../../../../../assets/icons/arrow-left-blue.svg';
import DeleteIcon from '../../../../../../../assets/icons/delete-border-icon.svg';
import Print from '../../../../../../../assets/icons/print-icon.svg';
import Edit from '../../../../../../../assets/icons/edit-icon-border.svg';
import ProductImage from '../../../../../../../assets/icons/product-image.svg';
import WarningIcon from '../../../../../../../assets/icons/warning-modal-icon.svg';
import Modal from "../../../../../../../components/uiComponent/modal"

import { BoxDetailsInfoWrapper, DeleteModalStyleWrapper } from '../../style';
import { DeleteBoxItem, GetBoxItems, GetWarehouseShipments, GetPackingItems } from '../../../../../../../slices/post-shipment';
import { GetOrderItems } from '../../../../../../../slices/work-orders';
import productLabel from '../../../../../../../utils/print-labels/productLabel';

const defaultColDef = {
  resizable: true,
  sortable: false,
  filter: false,
  suppressRowClickSelection: true,
  suppressMenu: true,
  suppressMovable: true,
};

const BoxDetailsInfoDrawer = ({
  setShowBoxItems,
  showBoxItems,
  boxIndex,
  boxesList,
  setDefaultTab
}) => {
  const dispatch = useDispatch();
  const { workOrderId } = useParams();

  const [isDeleteBox, setIsDeleteBox] = useState(false);
  const [boxItemIndex, setBoxItemIndex] = useState(-1);

  const {
    fetchingBoxItems,
    boxItems,
    deletingBoxItem,
    packingMethod
  } = useSelector((state) => state.postShipment || {});

  useEffect(() => {
    dispatch(GetBoxItems(boxesList[boxIndex]?.id));
  }, []);

  const handleDeleteBoxItem = () => {
    if (deletingBoxItem) return;
    const boxItemBody = {
      box_item_id: boxItems[boxItemIndex]?.id,
      box_id: boxesList[boxIndex]?.id,
      sku_id: boxItems[boxItemIndex]?.sku_info?.sku_id
    }
    dispatch(DeleteBoxItem(boxItemBody))
      .then(() => {
        setIsDeleteBox(false);
        setShowBoxItems(false);
        setDefaultTab();
        dispatch(GetWarehouseShipments({ workOrderId }));
        dispatch(GetPackingItems({ workOrderId }));
        dispatch(GetOrderItems({ workOrderId, page: { pageSize: 1000, pageNumber: 1 } }));
      });
  };

  const handleGenerateProductLabels = (boxItemIndex) => {
    const {
      boxed_quantity,
      sku_info: {
      item_name,
      prep_instructions,
      expiration,
      fnsku,
      min_bundle_quantity = 1,
      item_condition = '11'
      }
    } = boxItems[boxItemIndex] || {};

    const labelsData = {
      fnsku,
      title: item_name || '',
      expiryDate: expiration ? moment(expiration).format('MM-DD-YYYY') : 'N/A',
      bundleQty: min_bundle_quantity,
      numberOfLabels: boxed_quantity,
      username: "Opulent",
      prepInstruction: prep_instructions,
      item_condition
    };

    productLabel(labelsData);
  };

  const columnDefs = [
    {
      width: 35,
      // headerCheckboxSelection: true,
      // checkboxSelection: true
    },
    {
      headerName: "Title",
      sortable: true,
      flex: 1,
      filter: true,
      cellRenderer: ({ data }) => {
        const { image_url, item_name } = data?.sku_info || {};

        return (
          <div className='title-ui-wrapper'>
            <img
              src={image_url || ProductImage}
              alt="Product-image"
              style={{
                width: '36px',
                height: '36px',
                objectFit: 'contain'
              }}
            />
            <Tooltip placement='top' title={item_name || ''}>
              <p>
                {item_name || '---'}
              </p>
            </Tooltip>
          </div>
        )
      }
    },
    {
      headerName: 'SKU',
      field: 'sku_info.sku',
      sortable: true,
      flex: 1,
      filter: true,
    },
    {
      headerName: 'FNSKU',
      field: 'sku_info.fnsku',
      sortable: true,
      flex: 1,
      filter: true,
    },
    {
      headerName: 'Quantity',
      field: 'boxed_quantity',
      sortable: true,
      flex: 1,
      filter: true,
    },
    {
      headerName: 'Actions',
      sortable: true,
      filter: true,
      flex: 1,
      cellRenderer: ({ node }) => {
        return (
          <div className='input-wrapper'>
            <Tooltip title='Print'>
            <img src={Print} alt="Print"
              onClick={() => handleGenerateProductLabels(node.rowIndex)}
            />
            </Tooltip>
            <Tooltip title='Delete'>
            <img src={DeleteIcon} onClick={() => {
              setIsDeleteBox(true);
              setBoxItemIndex(node.rowIndex);
            }} alt="Delete" />
            </Tooltip>
          </div>
        )
      }
    },
  ];

  return (
    <>
      <Drawer
        placement="right"
        closable={false}
        width={996}
        onClose={() => setShowBoxItems(false)}
        visible={showBoxItems}
      >
        <BoxDetailsInfoWrapper>
          <header>
            <div className='items-wrapper'>
              <img onClick={() => setShowBoxItems(false)} src={LeftArrow} alt="LeftArrow" />
              <p>Box Details</p>
            </div>
          </header>
          <Spin tip='Loading...' spinning={fetchingBoxItems}>
            <AgGrid
              user_referrals={boxItems}
              defaultColDef={defaultColDef}
              columnDefinitions={columnDefs}
              rowHeight={64}
              headerHeight={36}
              height="112px"
              className="sku-table" />
          </Spin>
        </BoxDetailsInfoWrapper>
      </Drawer>

      <Modal
        saveText="Delete"
        className="Delete-modal-wrapper-item"
        onClose={() => setIsDeleteBox(false)}
        onSave={handleDeleteBoxItem}
        buttonDisabled={deletingBoxItem}

        closeText="Cancel" centerAlign size="small" open={isDeleteBox} removeIcon
      >
        <DeleteModalStyleWrapper>
          <div className='delete-modal-wrapper'>
            <img src={WarningIcon} alt='WarningIcon' title='WarningIcon' />
            <Typography fontSize={24} component="h3" marginTop={3}>Warning</Typography>
            <p>Are you sure you want to delete this box Item?</p>
          </div>
        </DeleteModalStyleWrapper>
      </Modal>
    </>
  );
}

export default BoxDetailsInfoDrawer;
